import React from 'react';
import { useWizard, WizardSubStep } from '@zillow/zrs-rental-applications';
import { Box, Heading, Icon, Paragraph } from '@zillow/constellation-10';
import { IconRateUnhappyFilled } from '@zillow/constellation-icons';
import { ExitReason, IdvStep } from '../../../../../models';
import { useIdVerificationCallbacks } from '../../../contexts/IdVerificationContext';

interface FrozenAccountWarningProps {
  id: string;
}

export default function FrozenAccountWarning({ id }: FrozenAccountWarningProps) {
  const { currentSubStep, onRequestStep } = useWizard();
  const { onExit } = useIdVerificationCallbacks();

  return (
    <WizardSubStep
      id={id}
      hidden={currentSubStep !== id}
      meta={{
        renderNextButton: 'Yes',
        renderBackButton: 'No',
      }}
      onRequestNext={(abortController: AbortController) => {
        abortController.abort();
        onRequestStep(IdvStep.PersonalInfoStep);
      }}
      onRequestPrev={(abortController: AbortController) => {
        abortController.abort();
        onExit({ reason: ExitReason.FrozenAccountWarning, success: false });
      }}
      render={() => (
        <Box css={{ display: 'flex', flexDirection: 'column', gap: 'default' }}>
          <Icon size="lg" css={{ color: 'icon.neutral' }}>
            <IconRateUnhappyFilled />
          </Icon>
          <Heading level={2} textStyle="heading-sm">
            Have you contacted Experian and unlocked your credit file?
          </Heading>
          <Paragraph>
            Our records indicate that your last attempt to verify your identity resulted in a frozen credit file
            notification from Experian. Continued attempts to verify your identity with a frozen credit file will result
            in a temporary lockout of the rental application service.
          </Paragraph>
        </Box>
      )}
    />
  );
}
